/*
 * @FileName       : report.reducer.ts
 * @Version        : 1.0
 * @DateOfCreation : 04/21/2020
 * @Author         : $u^^!t @ FFF Enterprises
 * @Dependencies   : N/A
 * @Description    : report reducer to handle report events.
 *
 * Copyright (c) 2020, FFF Enterprises. All rights reserved.
 */

import createReducer from './createReducer';
import { TenantsActions } from '../actions';
import { TENANTS } from '../constants/actions';

export const tenants = createReducer(
	{},
	{
		[TENANTS.LIST_RESPONSE](state = {}, action: ReturnType<typeof TenantsActions.successTenantsList>) {
			return { ...state, tenantsList: action.payload };
		},

		[TENANTS.DETAILS.DETAIL_LIST_RESPONSE](
			state = {},
			action: ReturnType<typeof TenantsActions.successTenantsDetails>,
		) {
			return { ...state, details: action.payload };
		},

		[TENANTS.CLEAR_TENANTS_LIST](state = {}, action: ReturnType<typeof TenantsActions.clearTenantsList>) {
			return { ...state, details: { result: [], total_record: 0 } };
		},

		[TENANTS.DETAILS.BASIC_INFO_RESPONSE](
			state = {},
			action: ReturnType<typeof TenantsActions.successTenantBasicInfo>,
		) {
			return { ...state, basicInfo: action.payload };
		},

		[TENANTS.DETAILS.ADDITIONAL_INFO_RESPONSE](
			state = {},
			action: ReturnType<typeof TenantsActions.setTenantAdditionalInfo>,
		) {
			return { ...state, additionalInfo: action.payload };
		},

		[TENANTS.DETAILS.NOTIFICATION_ACTIVITY_RESPONSE](
			state = {},
			action: ReturnType<typeof TenantsActions.setNotificationActivity>,
		) {
			return { ...state, notificationActivity: action.payload };
		},

		[TENANTS.DETAILS.NOTIFICATION_MESSAGE_RESPONSE](
			state = {},
			action: ReturnType<typeof TenantsActions.setNotificationActivity>,
		) {
			return { ...state, notificationMessage: action.payload };
		},

		[TENANTS.DETAILS.SET_PRODUCTS](state = {}, action: ReturnType<typeof TenantsActions.setTenantProducts>) {
			return { ...state, products: action.payload };
		},

		[TENANTS.SET_CREDIT_CARD_ELIGIBLE_PRODUCTS_FOR_CUSTOMER](
			state = {},
			action: ReturnType<typeof TenantsActions.setCreditCardEligibleProductsForCustomer>,
		) {
			return { ...state, CreditCardEligibleProductsForCustomer: action.payload }; //TODO: reduce to just list of ids???
		},

		[TENANTS.SET_CLASS_OF_TRADE_OPTIONS](state = {}, action: ReturnType<typeof TenantsActions.setClassOfTradeOptions>) {
			const classList = action.payload.map((classOfTrade: any) => {return {label: classOfTrade, value:classOfTrade}})
			return { ...state, classOfTradeOptions: classList }
		},
	
		[TENANTS.SET_FACILITY_TYPE_OPTIONS](state = {}, action: ReturnType<typeof TenantsActions.setFacilityTypeOptions>) {
		const facilityList = action.payload.map((facilityType: any) => {return {label: facilityType, value:facilityType}})
		return { ...state, facilityTypeOptions: facilityList }
		},
	},
);
